import {
  JustifiBalanceTransaction,
  StripeTransactionItem,
} from '@weave/schema-gen-ts/dist/schemas/payments-platform/payouts/v1';
import { formatDate } from '@frontend/date';
import { TFunction } from '@frontend/i18n';
import { TableColumnConfig } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../../utils/currency-helpers';
import { prettify } from '../../../utils/date-helpers';
import { setAndNotUnknown } from '../../../utils/helpers';

export const generateStripeColumns = (t: TFunction): TableColumnConfig<Partial<StripeTransactionItem>>[] => [
  {
    id: 'type',
    Header: t('Type', { ns: 'payments' }),
    accessor: (transaction) => prettify(transaction.transactionType ?? '', { split: '_' }),
    disableSortBy: true,
  },
  {
    id: 'personName',
    Header: t('Person Name', { ns: 'payments' }),

    accessor: (transaction) => transaction.personName,
    disableSortBy: true,
  },
  {
    id: 'patientId',
    Header: t('Patient ID', { ns: 'payments' }),
    accessor: (transaction) => (setAndNotUnknown(transaction.patientPmid, 3) ? transaction.patientPmid : '-'),
    disableSortBy: true,
  },
  {
    id: 'gross',
    Header: t('Gross', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.amount),
    disableSortBy: true,
  },
  {
    id: 'fee',
    Header: t('Fee', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.fee),
    disableSortBy: true,
  },
  {
    id: 'net',
    Header: t('Total', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.net),
    disableSortBy: true,
  },
  {
    id: 'createdAt',
    Header: t('Transaction Date', { ns: 'payments' }),
    accessor: (transaction) => formatDate(transaction.created, 'MMM D, YYYY'),
    disableSortBy: true,
  },
  {
    id: 'transactionId',
    Header: t('Confirmation Code', { ns: 'payments' }),
    accessor: (transaction) => transaction.confirmationCode,
    disableSortBy: true,
  },
  {
    id: 'payoutDate',
    Header: t('Payout Date', { ns: 'payments' }),
    accessor: (transaction) => formatDate(transaction.arrivalTime, 'MMM D, YYYY'),
    disableSortBy: true,
  },
];

export const generateJustifiColumns = (t: TFunction): TableColumnConfig<Partial<JustifiBalanceTransaction>>[] => [
  {
    id: 'type',
    Header: t('Type', { ns: 'payments' }),
    accessor: (transaction) => prettify(transaction.txnType ?? '', { split: '_' }),
    disableSortBy: true,
  },
  {
    id: 'gross',
    Header: t('Gross', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.amount),
    disableSortBy: true,
  },
  {
    id: 'fee',
    Header: t('Fee', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.fee),
    disableSortBy: true,
  },
  {
    id: 'net',
    Header: t('Total', { ns: 'payments' }),
    accessor: (transaction) => formatCentsToCurrency(transaction.net),
    disableSortBy: true,
  },
  {
    id: 'createdAt',
    Header: t('Transaction Date', { ns: 'payments' }),
    accessor: (transaction) => formatDate(transaction.createdTime, 'MMM D, YYYY'),
    disableSortBy: true,
  },
  {
    id: 'transactionId',
    Header: t('Confirmation Code', { ns: 'payments' }),
    accessor: (transaction) => transaction.id,
    disableSortBy: true,
  },
  {
    id: 'payoutDate',
    Header: t('Payout Date', { ns: 'payments' }),
    accessor: (transaction) => formatDate(transaction.createdTime, 'MMM D, YYYY'),
    disableSortBy: true,
  },
];
